// extracted by mini-css-extract-plugin
export var statItem = "_dm-1";
export var statsRow = "_dm-0";